import fileDownload from 'js-file-download';
import { GrDocumentPdf } from 'react-icons/gr';
import Grid from '../components/Grid';
import { Grid5W2H } from '../components/Grid5W2H';
import { GridAnexos } from '../components/GridAnexos';
import { GridChecklist } from '../components/GridChecklist';
import { GridDiario } from '../components/GridDiario';
import { GridPontosCriticos } from '../components/GridPontosCriticos';
import { AttachmentInput, CheckBoxInput, DateInput, DBSelectInput, GroupInput, Input, InputCurrency, MaskInput, SelectInput, TextInput, TimeInput } from '../components/Input';
import { useSystemContext } from '../Context/SystemContext';
import { dateToString } from '../helper/dates';

const moment = require('moment');


const yup = require('../interface/yup-br');

export const translateStatus = (status) => {
    switch (status) {
        case 1:
            return 'Pendente';
        case 2:
            return 'Operação';
        case 3:
            return 'Encerrado';
        case 4:
            return 'Adjudicado';
        case 5:
            return 'Anulado';
        case 6:
            return 'Revogado';
        case 7:
            return 'Desclassificado';
        case 8:
            return 'Habilitado';
        case 9:
            return 'Recurso';
        case 10:
            return 'Perdido';
        default:
            return 'Pendente';

    }
};


export const LicitaEdital = () => {
    const System = useSystemContext();

    async function _downloadFile(file) {
        const fileinfo = await System.apiGetFileInfo(file);
        const Ext = fileinfo.filename.split('.').pop();
        System.apiGetRawFile(file).then(async (response) => {
            if (response.status === 200) {
                fileDownload(response.data, file + '.' + Ext);
            }
        });
    }

    return (
        <div className="bg-white grow">
            <div className="w-full">
                <Grid
                    url={'/licitaedital'}
                    perms={'10'}
                    disableModal={true}
                    GridHeaders={[
                        { title: 'Data', field: 'cadastro', type: 'date', sort: true, className: 'w-1/12' },
                        { title: 'Numero', field: 'numeroLicitacao', sort: true, className: 'w-1/12' },
                        { title: 'Contratante', field: 'contratante', sort: true, className: 'w-3/12' },
                        { title: 'Objeto', field: 'objeto', sort: true, className: 'w-4/12' },
                        { title: 'Valor', field: 'valorOtiginal', sort: true, className: 'w-1/12 text-center' },
                        { title: 'Plataforma', field: 'plataformaOperacao.nome', sort: true, className: 'w-1/12' },
                        {
                            title: 'Status', field: 'status', sort: true, className: 'w-1/12',
                            filter: {
                                type: 'select',
                                definition: [
                                    { value: '1', label: 'Pendente' },
                                    { value: '2', label: 'Operação' },
                                    { value: '3', label: 'Encerrado' },
                                    { value: '4', label: 'Adjudicado' },
                                    { value: '5', label: 'Anulado' },
                                    { value: '6', label: 'Revogado' },
                                    { value: '7', label: 'Desclassificado' },
                                    { value: '8', label: 'Habilitado' },
                                    { value: '9', label: 'Recurso' },
                                    { value: '10', label: 'Perdido' },
                                ],
                            },
                        }
                    ]}
                    GridTitle="Cadastro de Editais"
                    LineDataPrint={(data) => {
                        return [
                            dateToString(data.cadastro),
                            data.numeroLicitacao,
                            data.contratante,
                            data.objeto,
                            data.valorOriginal,
                            data.plataformaOperacao?.nome,
                            translateStatus(data.status),
                        ];
                    }}
                    initialValues={{
                        cadastro: moment().format('YYYY-MM-DD')
                    }}
                    onRenderForm={(GridModes, SetFieldValue, values) => {
                        localStorage.setItem('autoEdit', null);
                        return (
                            <>
                                <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                    <span>{!GridModes.insert_mode ? 'Editar' : 'Novo registro'}</span>
                                </div>
                                {GridModes.insert_mode ? (
                                    <div className='p-2'>
                                        <GroupInput>
                                            <AttachmentInput name="arquivo" accept="application/pdf" label="Arquivo PDF Edital" />
                                        </GroupInput>
                                    </div>
                                ) : (
                                    <div className='p-2'>
                                        <GroupInput>
                                            <DateInput name="cadastro" label="Cadastro" className={'w-min'} />
                                            <Input name="numeroLicitacao" label="Número da licitação" className={'w-48'} />
                                            <SelectInput
                                                name="status"
                                                label="Status"
                                                defaultValue='1'
                                                listOptions={[
                                                    { option: 'Pendente', value: 1 },
                                                    { option: 'Operação', value: 2 },
                                                    { option: 'Encerrado', value: 3 },
                                                    { option: 'Adjudicado', value: 4 },
                                                    { option: 'Anulado', value: 5 },
                                                    { option: 'Revogado', value: 6 },
                                                    { option: 'Desclassificado', value: 7 },
                                                    { option: 'Habilitado', value: 8 },
                                                    { option: 'Recurso', value: 9 },
                                                    { option: 'Perdido', value: 10 },
                                                ]}
                                                className={'w-48'}
                                            />

                                        </GroupInput >
                                        <GroupInput>
                                            <Input name="contratante" label="Contratante" />
                                        </GroupInput>
                                        <GroupInput>
                                            <Input name="uasg" label="Código UASG" className={'w-48'} />
                                            <Input name="cidade" label="Município" />
                                        </GroupInput>
                                        <GroupInput>
                                            <Input name="objeto" label="Objeto" />
                                        </GroupInput>
                                        <GroupInput>
                                            <Input type="number" name="quantidade" label="Quantidade" className={'w-32'} />
                                            <InputCurrency name="valorOriginal" label="Valor Original" className={'w-40'} />
                                        </GroupInput>
                                        <GroupInput>
                                            <DateInput name="dataProposta" label="Data da proposta" className={'w-min'} />
                                            <TimeInput name="horarioLimiteProposta" label="Horário limite para envio de proposta" className={'w-64'} />
                                            <DateInput name="dataSessao" label="Data da Sessão" className={'w-min'} />
                                            <TimeInput name="horarioSessao" label="Horário da Sessão" className={'w-52'} />
                                        </GroupInput>
                                        <GroupInput>
                                            <Input name="modalidade" label="Modalidade" />
                                        </GroupInput>
                                        <GroupInput>
                                            <Input name="criterioJulgamento" label="Critério de Julgamento" />
                                        </GroupInput>
                                        <GroupInput>
                                            <DBSelectInput
                                                name="plataformaOperacaoID"
                                                label="Plataforma de Operação"
                                                url={'/licitaoperacaoactive'}
                                                displaySelectField="nome"
                                                className={'w-1/3'}
                                            />
                                        </GroupInput>
                                        <GroupInput>
                                            <InputCurrency name="valorProposta" label="Valor da Proposta" />
                                            <InputCurrency name="valorUltimoLance" label="Valor do último lance" />
                                            <InputCurrency name="valorVencedor" label="Valor Vencedor" />
                                            <InputCurrency name="valorVencedorPeloConcorrente" label="Valor Vencedor pelo Concorrente" />
                                        </GroupInput>
                                        <GroupInput>
                                            <Input name="consultorResponsavel" label="Consultor Responsável" />
                                            <InputCurrency name="percentualComissao" label="% Comissão" symbol="%" />
                                            <div className="flex flex-col w-full">
                                                <label className="text-sm font-medium text-gray-700">Valor em comissão</label>
                                                <span className="px-3 py-2 mt-1 text-gray-800 border border-gray-300 rounded bg-gray-50">
                                                    {(() => {
                                                        const parseBR = (v) => parseFloat((v ?? '').replace(/[^\d,]/g, '').replace(',', '.')) || 0;
                                                        return (parseBR(values.valorVencedor) * parseBR(values.percentualComissao) / 100)
                                                            .toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
                                                    })()}
                                                </span>
                                            </div>
                                        </GroupInput>
                                        <GroupInput>
                                            <Input name="contato" label="Contato" />
                                            <MaskInput name="telefone" label="Telefone" className={'w-1/2'} />
                                        </GroupInput>
                                        <GroupInput>
                                            <MaskInput name="whatsapp" label="WhatsApp Suporte" mask="(99) 9 9999-9999" className={'w-1/2'} />
                                            <Input name='email' label='Email' />
                                        </GroupInput>
                                        <GroupInput>
                                            <Input type="number" name="participantes" label="Participantes" className={'w-48'} />
                                        </GroupInput>
                                    </div>
                                )}
                            </>
                        );
                    }}
                    validationSchema={
                        yup.object().shape({
                            cadastro: yup.date().required('Data de cadastro obrigatória'),
                        })
                    }
                    FormTabs={
                        [
                            () => {
                                return <div>Gestão</div>;
                            },
                            () => {
                                return <div>Resumo</div>;
                            },
                            () => {
                                return <div>Pontos Críticos</div>;
                            },
                            () => {
                                return <div>Checklist</div>;
                            },
                            () => {
                                return <div>Itens do edital</div>;
                            },
                            () => {
                                return <div>Diário de Bordo</div>;
                            },
                            () => {
                                return <div>Anexos: Licitação</div>;
                            },
                            () => {
                                return <div>Anexos: Proposta</div>;
                            },
                            () => {
                                return <div>Anexos: Laudos</div>;
                            },
                            () => {
                                return <div>Anexos: Habilitação</div>;
                            },
                            () => {
                                return <div>5W2H</div>;
                            }
                        ]}
                    onRenderFormExtra={
                        [
                            (GridModes, item) => {
                                return (
                                    <>
                                        <div className="inline-flex w-full h-8 py-1 pl-2 justify-left bg-amarelo-eq">
                                            <span>Resumo do edital</span>
                                        </div>
                                        <div className='mt-2'>
                                            {item?.resumo && (
                                                <div className="p-4 m-2 border border-gray-300 rounded bg-gray-50">
                                                    {item.resumo}
                                                </div>
                                            )}
                                            <div className='w-64 p-4 m-2 border rounded-md cursor-pointer bg-botao-primario text-botao-primario-fonte hover:bg-botao-primario-hover hover:text-botao-primario-fonte'
                                                onClick={() => _downloadFile(item.arquivo)} >
                                                <GrDocumentPdf className="inline-flex w-6 h-6 text-gray-500 cursor-pointer hover:text-gray-700" />
                                                <span className='pl-2'>Download do edital original</span>
                                            </div>


                                        </div>

                                    </>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        {!GridModes.insert_mode && (
                                            <div className={'m-2'}>
                                                <GridPontosCriticos url={'/griddocument/criticos-' + item._id} perms={'10'} />
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        {!GridModes.insert_mode && (
                                            <div className={'m-2'}>
                                                <GridChecklist url={'/griddocument/checklist-' + item._id} perms={'10'} />
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        {!GridModes.insert_mode && (
                                            <div className={'m-2'}>
                                                <Grid
                                                    url={'/licitaeditalitem'}
                                                    url_get_all={'/licitaeditalitem/' + item._id}
                                                    perms={'10'}
                                                    disableModal={true}
                                                    hideIndexColumn={true}
                                                    initialValues={{ edital: item._id, participante: true, quantidade: 1, unidade: 'UN', valorFinal: 'R$ 0,00' }}
                                                    GridTitle="Itens do edital"
                                                    GridHeaders={[
                                                        { title: 'Descrição', field: 'descricao', sort: true, className: 'w-5/12 text-left pl-1' },
                                                        { title: 'Qtd', field: 'quantidade', type: 'number', sort: true, className: 'w-1/12 text-center' },
                                                        { title: 'Unidade', field: 'unidade', sort: true, className: 'w-1/12 text-center' },
                                                        { title: 'Valor Original', field: 'valorOriginal', sort: true, className: 'w-2/12 text-center' },
                                                        { title: 'Valor Final', field: 'valorFinal', sort: true, className: 'w-2/12 text-center' },
                                                        { title: 'Participante', field: 'participante', sort: true, className: 'w-1/12 text-center' },
                                                    ]}
                                                    LineDataPrint={(data) => {
                                                        return [
                                                            data.descricao,
                                                            data.quantidade,
                                                            data.unidade,
                                                            data.valorOriginal,
                                                            data.valorFinal,
                                                            data.participante
                                                                ? <span className="text-green-500">🟢 Sim</span>
                                                                : <span className="text-red-500">🔴 Não</span>,
                                                        ];
                                                    }}
                                                    onRenderForm={() => {
                                                        return (
                                                            <div className="p-2">
                                                                <GroupInput>
                                                                    <TextInput name="descricao" label="Descrição do item" rows={3} />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <Input name="quantidade" type="number" label="Quantidade" className={'w-32'} />
                                                                    <Input name="unidade" label="Unidade (ex: UN, KG)" className={'w-40'} />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <InputCurrency name="valorOriginal" label="Valor Original" className={'w-48'} />
                                                                    <InputCurrency name="valorFinal" label="Valor Final" className={'w-48'} />
                                                                </GroupInput>
                                                                <GroupInput>
                                                                    <CheckBoxInput name="participante" label="Participaremos deste item" />
                                                                </GroupInput>
                                                            </div>
                                                        );
                                                    }}
                                                    validationSchema={
                                                        yup.object().shape({
                                                            descricao: yup.string().required('Informe a descrição do item'),
                                                        })
                                                    }
                                                />
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        {!GridModes.insert_mode && (
                                            <div className={'m-2'}>
                                                <GridDiario url={'/griddocument/diariobordo-' + item._id} perms={'10'} />
                                            </div>
                                        )}
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        <GridAnexos
                                            url={'/attachment/edital-' + item._id}
                                            url_post={'/attachment/multi/edital-' + item._id}
                                            perms={'41'} disableModal allowMultiFiles />
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        <GridAnexos
                                            url={'/attachment/edital-proposta-' + item._id}
                                            url_post={'/attachment/multi/edital-proposta-' + item._id}
                                            perms={'41'} disableModal allowMultiFiles />
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        <GridAnexos
                                            url={'/attachment/edital-laudo-' + item._id}
                                            url_post={'/attachment/multi/edital-laudo-' + item._id}
                                            perms={'41'} disableModal allowMultiFiles />
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        <GridAnexos
                                            url={'/attachment/edital-habilitacao-' + item._id}
                                            url_post={'/attachment/multi/edital-habilitacao-' + item._id}
                                            perms={'41'} disableModal allowMultiFiles />
                                    </div>
                                );
                            },
                            (GridModes, item) => {
                                return (
                                    <div>
                                        <Grid5W2H url={`/method5w2h/licitaedital-${item._id}`} perms="10" />
                                    </div>
                                );
                            },

                        ]}
                    onBeforeDelete={async (item) => {
                        await System.apiDelete('/griddocument/diariobordo-' + item._id);
                        await System.apiDelete('/griddocument/checklist-' + item._id);
                        await System.apiDelete('/griddocument/criticos-' + item._id);
                        await System.apiDelete('/attachment/edital-' + item._id);
                    }}
                />
            </div >
        </div >
    );
}